import { Typography } from "../Typography";
import { StyledFilterButton } from "./styled";
import { IFilterButtonProps } from "./types";

const FilterButton = ({ label, onClick, isSelected }: IFilterButtonProps) => {
    return (
        <StyledFilterButton onClick={onClick} isSelected={isSelected}>
            <Typography variant={`${isSelected ? "h5" : "caption"}`}>{label}</Typography>
        </StyledFilterButton>
    )
}

export { FilterButton };